<template>
  <div>
    <div class="news-detail">
      <span @click="gotoHome" style="cursor: pointer">首页</span>
      <span>></span>
      <span @click="gotoMore" style="cursor: pointer">航运咨询</span>
      <span>></span>
      <span>{{ newsDetail.title }}</span>
    </div>
    <div
      class="news-bottom"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.3)"
    >
      <div class="news-content">
        <div class="content-title">{{ newsDetail.title }}</div>
        <div class="content-time">
          <div>{{ newsDetail.createTime }}</div>
          <div>浏览数:{{ newsDetail.readNum }}</div>
        </div>
        <!-- <div class="content-divder"></div> -->
        <div v-html="newsDetail.content"></div>
      </div>
      <div class="news-more">
        <div class="more-title">
          <div class="more-line"></div>
          <div class="more-font">推荐资讯</div>
        </div>
        <div v-for="(item, index) in newsList" :key="index" class="more-img">
          <img :src="item.imgPath" alt="" />
          <div class="more-imgLin">
            <div class="imgLin-font" @click="gotoNews(item)">
              {{ item.title }}
            </div>
            <div class="imgLin-time">
              <div>{{ item.createTime }}</div>
              <div>{{ item.readNum }}阅读</div>
            </div>
          </div>
        </div>
        <div class="watch-more" @click="gotoMore">查看更多</div>
      </div>
    </div>
    <!-- <img :src="imgSrc" alt="" /> -->
  </div>
</template>

<script>
import { querySeafarerNewsById, querySeafarerNewsList } from "@/apis/index";
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      test: "",
      newsDetail: {},
      imgSrc: "",
      newsList: [],
      loading: true,
    };
  },
  mounted() {
    this.newsDetail = {};
    this.getNews();
    this.querySeafarerNews();
  },
  created() {},
  methods: {
    //获取新闻详情信息
    async getNews() {
      const res = await querySeafarerNewsById({ id: this.$route.params.id });
      // console.log(res);
      if (res) {
        this.loading = false;
      }
      let date = new Date(res.createTime);
      res.createTime = date.toISOString().slice(0, 10);
      res.content = res.content.replace(/crossorigin="anonymous"/g, "");
      this.newsDetail = res;
    },
    //推荐资讯
    async querySeafarerNews() {
      let res = await querySeafarerNewsList({
        pageSize: 5,
        pageNo: 1,
      });
      //       const timestamp = 1686713742000;
      // const date = new Date(timestamp);
      // const formattedDate = date.toISOString().slice(0, 10);
      res.resultList.forEach((item) => {
        let date = new Date(item.createTime);
        item.createTime = date.toISOString().slice(0, 10);
      });
      this.newsList = res.resultList;

      // console.log(this.newsList);
    },
    //返回首页
    gotoHome() {
      this.$router.push("/home");
      // this.$forceUpdate;
    },
    //更多资讯页
    gotoMore() {
      this.$router.push({ name: "crewNewsMore" });
    },
    //点击推荐资讯详情
    gotoNews(item) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.$router.push({ name: "crewNewsDetail", params: { id: item.id } });
      this.getNews();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
